import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { differenceInDays } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';

import BoonLogo from '../../../../assets/images/boon-initial.svg';
import defaultProfileImg from '../../../../assets/images/default_profile_img.svg';
import { IsMobile } from '../../../../helpers/IsMobile';

import styles from './OpeningReferralCard.module.scss';

export const OpeningReferralCard = ({ referralProviderDetails, avatarThumb }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();
  const referralProviderCount = referralProviderDetails.length;
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const currentCard = referralProviderDetails[currentCardIndex];
  const handleNext = () => setCurrentCardIndex((prev) => (prev + 1) % referralProviderCount);
  const handlePrev = () => setCurrentCardIndex((prev) => (prev === 0 ? referralProviderCount - 1 : prev - 1));
  const referRequestExpired = 7 - differenceInDays(new Date(), new Date(currentCard.createdAt));
  return (
    <div className={styles.cardContainer}>
      <div className={styles.mobileArrowContainer}>
        <div className={styles.imageContainer}>
          <img src={avatarThumb || defaultProfileImg} alt="avatar" className={styles.avatarImage} />
          <div className={styles.boonLogo}>
            <img src={BoonLogo} alt="logo" />
          </div>
        </div>
        {referralProviderCount > 1 && isMobile ? (
          <div className={styles.buttonsContainer}>
            <button type="submit" className={styles.arrowButton} onClick={handlePrev}>
              {'<'}
            </button>
            <button type="submit" className={styles.arrowButton} onClick={handleNext}>
              {'>'}
            </button>
          </div>
        ) : null}
      </div>
      <div className={styles.cardDetails}>
        <div className={styles.titleContainer}>
          <h3 className={styles.title}>{t('browse.welcomeToBoon', { name: currentCard.name })} 👋</h3>
          {referralProviderCount > 1 && !isMobile ? (
            <div className={styles.buttonsContainer}>
              <button
                type="submit"
                className={styles.arrowButton}
                onClick={handlePrev}
                disabled={currentCardIndex === 0}
              >
                {'<'}
              </button>
              <button
                type="submit"
                className={styles.arrowButton}
                onClick={handleNext}
                disabled={currentCardIndex + 1 === referralProviderCount}
              >
                {'>'}
              </button>
            </div>
          ) : null}
        </div>
        {referRequestExpired >= 0 ? (
          <p className={styles.expiryPrompt}>{t('browse.referralExpiresIn', { count: referRequestExpired })}</p>
        ) : null}
        <p className={styles.description}>{currentCard.message}</p>
        {referralProviderCount > 1 ? (
          <div className={styles.bulletsContainer}>
            {referralProviderDetails.map((_, i) => (
              <span
                key={uuidv4()}
                className={classnames(styles.bullet, { [styles.activeBullet]: i === currentCardIndex })}
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
